import React from 'react'
import PropTypes from 'prop-types'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'
import Media from 'components/common/Media'

const BrandBreadcrumbs = ({ applyFilter, refinementCrumbs, resetFilters }) =>
  <Media.Desktop>
    <FilterBreadcrumbs
      selectedFilters={ refinementCrumbs }
      onFilterClear={ resetFilters }
      onFilterRemove={ applyFilter } />
  </Media.Desktop>

export default BrandBreadcrumbs

BrandBreadcrumbs.propTypes = {
  applyFilter: PropTypes.func,
  refinementCrumbs: PropTypes.arrayOf(PropTypes.object),
  resetFilters: PropTypes.func
}
